<ng-template #searchUploadFile>
	<cds-search (valueChange)="searchFiles($event)" [expandable]="false" size="lg"></cds-search>
	<button [size]="'lg'" (click)="this.httpService.reloadUserData()" cdsButton="secondary">
		Refresh Status
		<svg class="cds--btn__icon" cdsIcon="reset--alt" size="16"></svg>
	</button>
	<button [size]="'lg'" (click)="this.syncService.updatePage('upload-files')" cdsButton="primary">
		Upload Files
		<svg class="cds--btn__icon" cdsIcon="document--add" size="16"></svg>
	</button>
	<button *ngIf="currentDeal" [size]="'lg'" (click)="compileData()" cdsButton="primary">
		Compile Data
		<svg class="cds--btn__icon" cdsIcon="data-collection" size="16"></svg>
<!--		<svg class="cds&#45;&#45;btn__icon" cdsIcon="partition&#45;&#45;collection" size="16"></svg>-->
	</button>
</ng-template>

<ng-template #fileMenu let-actionData class="overflowMenu">

	<ibm-icon-button (click)="downloadFile(actionData[0])" *ngIf="this.hoveringOverItem === actionData[0]['File Name'] + '_' + actionData[1].toString()" type="button" kind="ghost" description="Download File" align="bottom" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="download" size="16"></svg>
	</ibm-icon-button>

	<ibm-icon-button (click)="openEditFileModal(actionData[0])" *ngIf="this.hoveringOverItem === actionData[0]['File Name'] + '_' + actionData[1].toString()" type="button" kind="ghost" description="Edit File" align="bottom" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="edit" size="16"></svg>
	</ibm-icon-button>

	<ibm-icon-button [disabled]="!actionData[0]['Files Document'] || actionData[0]['File Status'] === 'active'" (click)="extractData(actionData[0])" *ngIf="this.hoveringOverItem === actionData[0]['File Name'] + '_' + actionData[1].toString()" type="button" kind="ghost" description="Reprocess File" align="bottom" style="z-index: 0">
<!--	<ibm-icon-button (click)="extractData(actionData[0])" *ngIf="this.hoveringOverItem === actionData[0]['File Name'] + '_' + actionData[1].toString()" type="button" kind="ghost" description="Reprocess File" align="bottom" style="z-index: 0">-->
		<svg class="cds--btn__icon" cdsIcon="restart" size="16"></svg>
	</ibm-icon-button>

	<ibm-icon-button (click)="this.exportExcel(actionData[0])" *ngIf="this.hoveringOverItem === actionData[0]['File Name'] + '_' + actionData[1].toString()" type="button" kind="ghost" description="Export Data" align="bottom" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="document--export" size="16"></svg>
	</ibm-icon-button>

	<ibm-icon-button *ngIf="this.hoveringOverItem === actionData[0]['File Name'] + '_' + actionData[1].toString()" (click)="confirmFileDeletion(actionData[0])" type="button" kind="ghost" description="Delete File" align="bottom-right" style="z-index: 0">
		<svg class="cds--btn__icon" cdsIcon="trash-can" size="16"></svg>
	</ibm-icon-button>
</ng-template>

<div @fadeInUp class="files-container">
	<cds-contained-list [action]="searchUploadFile" label="Files" (mouseleave)="enteringContainedListItem(null)">
		<cds-contained-list-item *ngFor="let file of displayFiles; let i = index" [clickable]="true" (click)="onFileClick($event, file)" (mouseenter)="enteringContainedListItem(file['File Name'] + '_' + i.toString())" [action]="fileMenu" [actionData]="[file, i]">
			<ng-container style="padding: 0" ibmContainedListItemButton>
				<div class="row" style="display: flex; margin: 0 !important">
					<div style="width: 32px !important; height: 16px; margin-top: -5.25px; padding: 0">
						<cds-inline-loading [state]="checkFileStatus(file)">
						</cds-inline-loading>
					</div>
					<div style="width: calc(100% - 32px)">
						{{file['File Name']}}
					</div>
				</div>
			</ng-container>
		</cds-contained-list-item>
	</cds-contained-list>
</div>

<cds-modal size="sm" [open]="editFileModalOpen">
	<cds-modal-header>
		<h3 cdsModalHeaderHeading>
			Edit {{this.fileName}}
		</h3>
	</cds-modal-header>
	<section cdsModalContent #cdsModalContent [hasForm]="true">

<!--		<cds-text-label style="margin: 8px 0" [invalid]="fileNameInvalid" [invalidText]="fileNameInvalidText">-->
<!--			File Name-->
<!--			<input (keyup.enter)="onSaveFileClick()" size="md" [(ngModel)]="this.fileName" (keyup)="onKeyUpFileName($event)" cdsText type="text" class="input-field" placeholder="New Deal">-->
<!--		</cds-text-label>-->

		<div #comboBox class="sub-div">
			<cds-combo-box
				class=".cds-combo-box"
				label="File Types"
				type="multi"
				[items]="fileTypeItems"
				placeholder="Select File Type"
				[(ngModel)]="currentFileTypes"
				(selected)="onSelectFileTypes($event)"
			>
			  <cds-dropdown-list></cds-dropdown-list>
			</cds-combo-box>
		</div>

		<div #datePicker style="margin: 8px 0">
			<cds-date-picker
				(keyup.enter)="onSaveFileClick()"
				label="File Reference Date"
				[value]="fileReferenceDateObject"
				invalidText="Select a pricing reference date."
				(valueChange)="onSelectReferenceDate($event)"
			></cds-date-picker>
		</div>
	</section>

	<cds-modal-footer>
		<button class="cds--btn cds--btn--secondary" (click)="closeModal()">
			Cancel
		</button>
		<button class="cds--btn cds--btn--primary" (click)="onSaveFileClick()">
			Save
		</button>
	</cds-modal-footer>
</cds-modal>
